import { render } from "./InternalMedicineClinicPage.vue?vue&type=template&id=e5ecee42"
import script from "./InternalMedicineClinicPage.vue?vue&type=script&lang=js"
export * from "./InternalMedicineClinicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__